// Copyright (c) 2016 Deere & Company

import SettlementNoRegistration from './components/settlement-no-registration-report';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {mapBoundActionCreatorsToActionsProp} from '../../../src/shared/services/state-connector';

const getStateToBindToContainerProps = state => ({
    ...state.reports.settlementNoRegistration,
    columnApi: state.columnApi,
    generalSettings: state.user.details.settings.general,
    gridApi: state.gridApi,
    isDefaultColumnStateAvailable: state.reportVariant.layouts.length ? Boolean(state.reportVariant.layouts.find(layout => layout.name === '').columnState.length) : false,
    isInitialLoad: state.reportVariant.isInitialLoad,
    isReportColumnsVisible: state.reportVariant.isReportColumnsVisible,
    layouts: state.reportVariant.layouts,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts,
    selectedLayout: state.reportVariant.selectedLayout
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(SettlementNoRegistration);



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/state-connector.js